// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal-company-info .modal-header{margin-top:0}.modal-company-info .modal-header h2{font-size:33px}.modal-company-info .modal-header h3{font-size:29px}.modal-company-info .modal-header h2,.modal-company-info .modal-header h3{margin:10px auto;text-align:center}.modal-company-info .modal-container{text-align:left!important;width:auto!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
